import React, { useState } from 'react';
import { toggleFollow } from '../../src/js/lib/follows';

const FollowButton = ({
  athleteId,
  initialFollowing = false,
  simple = false,
}) => {
  const [following, setFollowing] = useState(initialFollowing);
  const [loading, setLoading] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const handleFollowToggle = async () => {
    if (loading) return;

    setLoading(true);

    try {
      const response = await toggleFollow(athleteId, following);
      setFollowing(response.following);
    } catch (error) {
      console.error('Error toggling follow:', error);
      // Optionally show error to user
    } finally {
      setLoading(false);
    }
  };

  const getButtonText = () => {
    if (loading) return 'Loading...';
    if (following && isHovering) return 'Unfollow';
    if (following) return 'Following';
    return 'Follow';
  };

  if (simple) {
    // Simple layout - just text, no borders
    return (
      <button
        onClick={handleFollowToggle}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        disabled={loading}
        className={`underline hover:no-underline ${
          loading ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
      >
        {getButtonText()}
      </button>
    );
  }

  // Default styled layout with padding and border
  return (
    <button
      onClick={handleFollowToggle}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      disabled={loading}
      className={`w-24 px-2 text-center py-1 border border-border rounded-md font-medium transition-all ${
        isHovering ? 'border-opacity-50' : ''
      } ${loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      {getButtonText()}
    </button>
  );
};

export default FollowButton;
